export const isRecognitionMode = (company) => {
  return company?.recognitionSettings?.rewardsEarnedMechanism === 'recognition';
};

export const isMilestoneMode = (company) => {
  return company?.recognitionSettings?.rewardsEarnedMechanism === 'milestone';
};

export const shouldShowRecentActivity = (company) => {
  return isRecognitionMode(company);
};

export const shouldShowRewardsProgress = (company) => {
  return isMilestoneMode(company);
};

export const getActivityDisplayMode = (company) => {
  if (isRecognitionMode(company)) {
    return 'recent_activity';
  } else {
    return 'rewards_progress';
  }
};

export const formatActivityTitle = (mode) => {
  switch (mode) {
    case 'recent_activity':
      return 'Recognitions to Claim';
    case 'rewards_progress':
      return 'Rewards Progress';
    default:
      return 'Recognitions to';
  }
};


export const shouldCreateSnappyGift = (badgeAssignment, company) => {
  const inRecognitionMode = isRecognitionMode(company);
  const hasSnappyGrant = badgeAssignment.snappyGrantId && !badgeAssignment.sentWithoutSnappyGrant;
  const assignSnappyReward = company?.recognitionSettings?.assignSnappyRewardToRecognition === true;
  
  return inRecognitionMode && hasSnappyGrant && assignSnappyReward;
};

export const getRecognitionNotificationMessage = (badgeAssignment, company) => {
  const inRecognitionMode = isRecognitionMode(company);
  const hasGift = badgeAssignment.snappyGrantId && !badgeAssignment.sentWithoutSnappyGrant;
  
  if (inRecognitionMode) {
    if (hasGift) {
      return 'Your Recognition included a gift! Check Recent Activity to claim it.';
    } else {
      return 'You received a recognition badge! Check Recent Activity to view it.';
    }
  } else {
    if (hasGift) {
      return 'Your Recognition included a gift! Click the icon to find out more.';
    } else {
      return 'You received a recognition badge!';
    }
  }
};

export const sanitizeActivityData = (activity) => {
  const sanitized = { ...activity };
  
  if (sanitized.rawData) {
    const sanitizedRawData = { ...sanitized.rawData };
    
    delete sanitizedRawData.costInCurrency;
    delete sanitizedRawData.remainingBudget;
    delete sanitizedRawData.budgetAfterTotal;
    delete sanitizedRawData.budgetBeforeTotal;
    delete sanitizedRawData.recognitionAmount;
    delete sanitizedRawData.currentBudget;
    delete sanitizedRawData.amountPending;
    delete sanitizedRawData.additionalBudgetTotal;
    
    if (sanitizedRawData.user?.recognitionEvents) {
      delete sanitizedRawData.user.recognitionEvents;
    }
    
    if (sanitizedRawData.eventList) {
      delete sanitizedRawData.eventList;
    }
    
    sanitized.rawData = sanitizedRawData;
  }
  
  return sanitized;
};

export default {
  isRecognitionMode,
  isMilestoneMode,
  shouldShowRecentActivity,
  shouldShowRewardsProgress,
  getActivityDisplayMode,
  formatActivityTitle,
  shouldCreateSnappyGift,
  getRecognitionNotificationMessage,
  sanitizeActivityData
};